import { AccountModelExt } from "@GeriMed/Type/ApiModelsExt";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const accountsUrl = "/api/v2/accounts";

export interface AddAccountApiParameterExt extends ApiParameter {
    account: AccountModelExt;
}

export async function addAccountExt(parameter: AddAccountApiParameterExt): Promise<ServiceResult<AccountModelExt>> {
    try {
        const accountModel = await post<AccountModelExt>(`${accountsUrl}`, parameter.account as AccountModelExt);
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}